import _routes from './routes';
import _reducer from './reducer';
import _Group from './model';
import * as _actions from './actions';

export const routes = _routes;
export const reducer = _reducer;
export const Group = _Group;
export const actions = _actions;



// WEBPACK FOOTER //
// ./containers/Group/index.js